import styled from "styled-components";

export const LoginWrapper = styled.div`
  .image-title {
    position: absolute;
    z-index: 1;
    top: 22px;
    left: ${({ lang }) => (lang === "en" ? "22px" : "unset")};
    right: ${({ lang }) => (lang === "ar" ? "22px" : "unset")};

    .image-title-one {
      color: var(--white);
      font-size: 32px;
      font-weight: 300;

      @media (max-width: 938px) {
        font-size: 26px;
      }
    }
    .image-title-two {
      color: var(--white);
      font-size: 32px;
      font-weight: 600;
      @media (max-width: 938px) {
        font-size: 26px;
      }
    }

    @media (max-width: 1024px) {
      top: 10px;
    }
    @media (max-width: 814px) {
      top: 7px;
    }
  }

  .image-title-sub-title {
    color: var(--white);
    width: 70%;
    font-size: 16px;
    line-height: 20px;
    @media (max-width: 1005px) {
      width: 98%;
    }
    @media (max-width: 938px) {
      font-size: 14px;
    }
    @media (max-width: 814px) {
      line-height: 16px;
    }
  }
  .or-separator {
    position: relative;
    &::before,
    &::after {
      content: "";
      flex: 1;
      border-bottom: 2px solid var(--borderLight);
    }

    &::before {
      margin-right: 10px;
    }

    &::after {
      margin-left: 10px;
    }
  }
`;
